import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SaveIcon from "@mui/icons-material/Save";

// Importar a lógica de importação
import EnhancedImportStock from "./EnhancedImportStock";

// Importar os passos do processo
import FileUploadStep from "./steps/FileUploadStep";
import ColumnMappingStep from "./steps/ColumnMappingStep";
import DataReviewStep from "./steps/DataReviewStep";
import ExpenseConfigStep from "./steps/ExpenseConfigStep";
import ConfirmationStep from "./steps/ConfirmationStep";

// Importar estilos
import "./EnhancedImportStock.scss";

function ModalEnhancedImportStock({
  stock,
  handleCloseModal,
  sendRequest,
  produtos,
  atualizarStock,
  categoriasStock,
  open,
}) {
  // Inicializar a lógica de importação
  // Se o modal não estiver aberto, não renderize nada
  if (!open) return null;

  // Use a lógica de importação normalmente
  const logic = EnhancedImportStock({
    stock,
    handleCloseModal,
    sendRequest,
    produtos,
    atualizarStock,
    categoriasStock,
  });
  // Definir os passos do processo
  const steps = [
    "Carregar Arquivo",
    "Mapear Colunas",
    "Revisar Dados",
    "Configurar Despesa",
    "Confirmar",
  ];

  // Renderizar o conteúdo baseado no passo atual
  const renderStepContent = () => {
    switch (logic.currentStep) {
      case 1:
        return <FileUploadStep logic={logic} />;
      case 2:
        return <ColumnMappingStep logic={logic} />;
      case 3:
        return (
          <DataReviewStep logic={logic} categoriasStock={categoriasStock} />
        );
      case 4:
        return <ExpenseConfigStep logic={logic} />;
      case 5:
        return <ConfirmationStep logic={logic} stock={stock} />;
      default:
        return <FileUploadStep logic={logic} />;
    }
  };

  return (
    <Modal
      open={true}
      onClose={handleCloseModal}
      aria-labelledby="modal-import-stock"
      className="enhanced-import-modal"
    >
      <Box className="enhanced-import-container">
        <div className="enhanced-import-header">
          <h2>Importação Avançada de Stock</h2>
          <IconButton
            onClick={handleCloseModal}
            className="enhanced-import-close-button"
            disabled={logic.isSubmitting || logic.isProcessingData}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <Stepper
          activeStep={logic.currentStep - 1}
          alternativeLabel
          className="enhanced-import-stepper"
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <div className="enhanced-import-content">{renderStepContent()}</div>

        <div className="enhanced-import-actions">
          {logic.currentStep > 1 && (
            <Button
              variant="outlined"
              onClick={logic.handlePreviousStep}
              startIcon={<ArrowBackIcon />}
              disabled={logic.isSubmitting || logic.isProcessingData}
            >
              Voltar
            </Button>
          )}

          {logic.currentStep < 5 ? (
            <Button
              variant="contained"
              color="primary"
              onClick={logic.handleNextStep}
              endIcon={
                logic.isProcessingData ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <ArrowForwardIcon />
                )
              }
              disabled={
                logic.isSubmitting ||
                logic.isProcessingData ||
                (logic.currentStep === 1 &&
                  (!logic.file || logic.errorMessage)) ||
                (logic.currentStep === 2 &&
                  (!logic.processedData || logic.processedData.length === 0))
              }
            >
              Continuar
            </Button>
          ) : (
            <Button
              variant="contained"
              color="success"
              onClick={logic.handleSubmitImport}
              startIcon={
                logic.isSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <SaveIcon />
                )
              }
              disabled={
                logic.isSubmitting ||
                logic.isProcessingData ||
                logic.processedData.length === 0
              }
            >
              {logic.isSubmitting ? "Processando..." : "Finalizar Importação"}
            </Button>
          )}
        </div>
      </Box>
    </Modal>
  );
}

export default ModalEnhancedImportStock;
